import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';

interface Product {
  id: string;
  name: string;
  code: string;
}

interface OrderItem {
  quantity: number;
  products: Product;
}

interface Order {
  id: string;
  order_number: string;
  created_at: string;
  status: string;
  responsible_name: string;
  construction_name: string;
  departments: {
    name: string;
  };
  order_items: OrderItem[];
}

export const generatePDF = async (order: Order): Promise<Blob> => {
  // Criar nova instância do PDF
  const doc = new jsPDF();

  // Configurações de fonte e cor
  doc.setFont('helvetica');
  doc.setTextColor(0, 0, 0);

  // Cabeçalho
  doc.setFontSize(20);
  doc.text('Detalhes do Pedido', 105, 20, { align: 'center' });

  // Informações do pedido
  doc.setFontSize(12);
  doc.text(`Pedido #${order.order_number}`, 20, 40);
  doc.text(`Data: ${new Date(order.created_at).toLocaleDateString('pt-BR')}`, 20, 50);
  doc.text(`Solicitante: ${order.responsible_name}`, 20, 60);
  doc.text(`Departamento: ${order.departments?.name}`, 20, 70);
  doc.text(`Local da Obra: ${order.construction_name}`, 20, 80);
  doc.text(`Status: ${order.status.charAt(0).toUpperCase() + order.status.slice(1)}`, 20, 90);

  // Tabela de produtos
  const tableData = order.order_items.map(item => [
    item.products.name,
    item.products.code,
    item.quantity.toString()
  ]);

  autoTable(doc, {
    startY: 100,
    head: [['Produto', 'Código', 'Quantidade']],
    body: tableData,
    theme: 'grid',
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
      fontSize: 12,
      fontStyle: 'bold'
    },
    bodyStyles: {
      fontSize: 11
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245]
    }
  });

  // Rodapé
  const pageCount = (doc as any).internal.getNumberOfPages();
  doc.setFontSize(10);
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.text(
      `Página ${i} de ${pageCount}`,
      doc.internal.pageSize.getWidth() / 2,
      doc.internal.pageSize.getHeight() - 10,
      { align: 'center' }
    );
  }

  // Retornar o PDF como Blob
  return doc.output('blob');
};
